import ProjectContent from "./projectsContent";

export default function ProjectPage() {
  return <ProjectContent />;
}
